var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-dropdown',{attrs:{"selected":_vm.selectedLanguage,"listItems":_vm.languageList,"isSelected":_vm.onChange,"customClass":"ed-dropdown__sm"}})}
var staticRenderFns = []

export { render, staticRenderFns }